import React from 'react'
import { ViewMode } from "gantt-task-react";

interface Props {
    onChangeView: (v: ViewMode) => void;
}

export default function TimeControl({ onChangeView }: Props) {
    return (
        <>
            <button
                onClick={() => onChangeView(ViewMode.QuarterDay)}
                className="text-sm px-2 py-1 bg-blue-50 hover:bg-blue-100 rounded"
            >
                Quarter Day
            </button>
            <button
                onClick={() => onChangeView(ViewMode.HalfDay)}
                className="text-sm px-2 py-1 bg-blue-50 hover:bg-blue-100 rounded"
            >
                Half Day
            </button>
            <button
                onClick={() => onChangeView(ViewMode.Day)}
                className="text-sm px-2 py-1 bg-blue-50 hover:bg-blue-100 rounded"
            >
                Day
            </button>
            <button
                onClick={() => onChangeView(ViewMode.Week)}
                className="text-sm px-2 py-1 bg-blue-50 hover:bg-blue-100 rounded"
            >
                Week
            </button>
            <button
                onClick={() => onChangeView(ViewMode.Month)}
                className="text-sm px-2 py-1 bg-blue-50 hover:bg-blue-100 rounded"
            >
                Month
            </button>
        </>
    );
}
